window.UpngB2b = window.UpngB2b || {};

window.UpngB2b.validarNIF = function validarNIF(nif) {
  if (typeof nif !== 'string') return false;
  nif = nif.toUpperCase().trim();

  const dniRegex = /^[0-9]{8}[A-Za-z]$/;
  if (dniRegex.test(nif)) {
    const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const numero = parseInt(nif.slice(0, 8), 10);
    return nif[8] === letras[numero % 23];
  }

  const nieRegex = /^[XYZ][0-9]{7}[A-Za-z]$/;
  if (nieRegex.test(nif)) {
    const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const conversion = { X: '0', Y: '1', Z: '2' };
    const nieNumerico = conversion[nif[0]] + nif.slice(1, 8);
    const numero = parseInt(nieNumerico, 10);
    return nif[8] === letras[numero % 23];
  }

  const nifPortugalRegex = /^\d{9}$/;
  if (nifPortugalRegex.test(nif)) {
    const firstDigit = parseInt(nif[0], 10);
    const validStartDigits = [1, 2, 5, 6, 8, 9];
    if (!validStartDigits.includes(firstDigit)) return false;
    let sum = 0;
    for (let i = 0; i < 8; i++) {
      sum += parseInt(nif[i], 10) * (9 - i);
    }
    let controlDigit = 11 - (sum % 11);
    if (controlDigit >= 10) controlDigit = 0;
    return controlDigit === parseInt(nif[8], 10);
  }

  const cifEspRegex = /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/;
  if (cifEspRegex.test(nif)) {
    const letraInicial = nif[0];
    const cuerpo = nif.slice(1, 8);
    const controlChar = nif[8];
    let sumaPares = 0;
    for (let i = 1; i < cuerpo.length; i += 2) {
      sumaPares += parseInt(cuerpo[i], 10);
    }
    let sumaImpares = 0;
    for (let i = 0; i < cuerpo.length; i += 2) {
      const doble = 2 * parseInt(cuerpo[i], 10);
      sumaImpares += Math.floor(doble / 10) + (doble % 10);
    }
    const total = sumaPares + sumaImpares;
    const controlNum = (10 - (total % 10)) % 10;
    const controlLetra = 'JABCDEFGHI'[controlNum];
    if ('PQRSNW'.includes(letraInicial)) {
      return controlChar === controlLetra;
    } else if ('ABEHJ'.includes(letraInicial)) {
      return controlChar === String(controlNum);
    }
    return controlChar === controlLetra || controlChar === String(controlNum);
  }

  return false;
};
